module.exports = __webpack_public_path__ + "app-static/img/empty_3.f9a3ef93.png";